import { Component, OnInit, Injector } from '@angular/core';
import { QuotesMonitorComponent } from '../quotes-monitor/quotes-monitor.component';
import { monitorPeriodsService } from '../../services/monitorPeriods/monitorPeriods.service';
import { dragAndDropSymbol } from '../../services/dragAndDropSymbol/dragAndDropSymbol.service';
import { MonitorSelectedSymbol } from '../../model/monitor.selected.symbol';
import { setTimeout } from 'timers';

@Component({
  selector: 'app-mobile-quotes-monitor',
  template: require('./mobile-quotes-monitor.component.html'),
  styles: [require('./mobile-quotes-monitor.component.scss')]
})
export class MobileQuotesMonitorComponent  extends QuotesMonitorComponent implements OnInit  {

  constructor(
    injector: Injector,
     monitorPeriodsService: monitorPeriodsService,
     dragAndDropSymbol: dragAndDropSymbol
  ) {

    super(injector, monitorPeriodsService, dragAndDropSymbol);

  //  this.runStandardSymbols(this.workspace.activeSymbolType, this.dataService, monitorPeriodsService);

  this.selectedSymbols = [];
  if (this.workspace.activeBasket != -1) {
      let symbols: string[] = this.workspace.getBasketItems(this.workspace.activeBasket);
      symbols.forEach(s => {
          this.selectedSymbolsData[s] =
              this.selectedSymbolsData[s] ||
              new MonitorSelectedSymbol(
                  this.dataService,
                  this.workspace,
                  s,
                  100,
                  monitorPeriodsService,
                  this.wakeUp
              );
      });
      this.selectedSymbols = symbols;
  } else {
  
      this.runStandardSymbols(this.workspace.activeSymbolType, this.dataService, monitorPeriodsService);
  }
 // this.updateFix();
 // this.workspace.AppTick()
   }


   private _currentSymbolOpen: string = "";
  public get currentSymbolOpen (): string {
    return this._currentSymbolOpen;
  }
  public set currentSymbolOpen ( value: string ) {
    this._currentSymbolOpen = value;
  }

   public openSymbol(v:any)
   {

      if(this.currentSymbolOpen!=v)
      {
        this.currentSymbolOpen = v;
      }
      else
      {
        this.currentSymbolOpen = "";
      }
      
   }




  ngOnInit() {
   
  }
  

  public timeo:any;
  public updateFix()
  {
    clearTimeout(this.timeo);
    this.timeo = setTimeout(() => {
       console.log("this.selectedSymbols A");
       console.log(this.selectedSymbols);

       if(this.selectedSymbols.length==0)
       {
     
       let l = this.activeBasket;

       this.activeBasket = -1;
       this.activeBasket = l;
 
       if(this.workspace.getActiveBasketItems().length==0)
       {
        this.updateFix()
       }
      }
    }, 500);
  }








  ngOnDestroy(){ 

  }
}
